const PanelSizes = {
  main: {
    order: 1,
    min: 30,
    max: 100,
    defaultSize: 100
  },
  sidebar: {
    order: 2,
    min: 18.5,
    max: 32,
    defaultSize: 25.5,
    /** Default pixel width used when the sidebar renders as a floating overlay. */
    overlayWidth: 300,
    /** Minimum pixel width for the overlay sidebar. */
    overlayMinWidth: 240,
    /** Maximum pixel width for the overlay sidebar. */
    overlayMaxWidth: 400
  },
  devtools: {
    order: 2,
    min: 30,
    max: 60,
    defaultSize: 30
  }
};

export default PanelSizes;
